var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.52 4.6875C20.7641 4.68244 25.0023 8.66629 25.3109 13.9032C25.6389 19.4702 21.0947 24.2761 15.52 24.2708C13.9306 24.2693 12.7212 23.9746 11.497 23.4059L5.92149 25.2644C5.58461 25.3767 5.21321 25.289 4.96211 25.0379C4.71102 24.7868 4.62334 24.4154 4.73563 24.0785L6.59412 18.5031C6.0254 17.2791 5.72991 16.0695 5.72919 14.4796C5.7283 12.5168 6.17397 10.7672 7.09786 9.27447C8.02163 7.78193 9.38882 6.60219 11.1429 5.72417C12.6934 4.94803 13.7859 4.68918 15.52 4.6875ZM23.4391 14.0135C23.1891 9.77008 19.7744 6.5584 15.5218 6.5625C14.0786 6.5639 13.2728 6.75481 11.9822 7.40084C10.4856 8.14995 9.4041 9.11101 8.69219 10.2612C7.9804 11.4113 7.60343 12.8065 7.60419 14.4787C7.60484 15.9117 7.88313 16.9104 8.441 18.0148C8.5537 18.2379 8.57263 18.4968 8.49358 18.734L7.10734 22.8927L11.2661 21.5064C11.5032 21.4274 11.7621 21.4463 11.9852 21.559C13.0894 22.1167 14.0881 22.3945 15.5217 22.3958C20.0188 22.4001 23.7036 18.5008 23.4391 14.0135Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.e92ac979a7739431fbefd546edabafee.svg";
export { ForwardRef as ReactComponent };